import { isAndroid, isIOS, isMobile } from 'react-device-detect';
import { useSelector } from 'react-redux';
import RaisedButton from '@guestyci/foundation/RaisedButton/RaisedButton';
import Button from '@guestyci/foundation/Button';
import TextField from '@guestyci/foundation/TextField';
import { Col } from '@guestyci/foundation/Layout';
import createStyles from '@guestyci/foundation/esm/createStyles/createStyles';
import useTranslations from '@guestyci/localize/useTranslations/useTranslations';
import _extends from '@babel/runtime/helpers/esm/extends';
import { APPLE_STORE_APP_LINK, PLAY_STORE_APP_LINK } from 'app/constants/constants';
import selectAppState from 'app/store/selector';

import iosImageSourceBtn from 'resources/ios-mobile-download-btn.svg';
import androidImageSourceBtn from 'resources/android-download-btn.svg';

import AppStyle from 'app/Styles';
import Translations from 'app/Translations';

const useStyles = createStyles(() =>
  _extends(AppStyle, {
    mobileButton: {
      display: 'flex',
      justifyContent: 'center',
      borderRadius: '6rem',
      border: '1px solid #0F265C',
      width: '100%',
      minWidth: '11.25rem', // 180px
      height: '3.125rem',
    },
  }));

const MarketingLoginButton = ({ eventCallBack, successLink, className = '', children }) => {
  const classes = useStyles();
  const state = useSelector(selectAppState);
  const [, buttonLabelMobile] = useTranslations(Translations.step3.buttons);

  const buttonClicked = () => {
    eventCallBack?.();
  };

  if (isMobile) {
    return (
      <Col spacing={3} align="center" id="mobile-link-buttons-container">
        <TextField
          variant="h3"
          align="center"
          id="mobile-link-label"
          className="font-weight-light mb-2"
        >
          {buttonLabelMobile}
        </TextField>
        {isIOS && (
          <a
            href={state.mobileLink || APPLE_STORE_APP_LINK}
            id="mobile-link-button-ios"
            rel="noreferrer"
          >
            <Button onClick={buttonClicked} className={classes.mobileButton}>
              <img src={iosImageSourceBtn} alt={buttonLabelMobile} />
            </Button>
          </a>
        )}
        {isAndroid && (
          <a
            href={state.mobileLink || PLAY_STORE_APP_LINK}
            id="mobile-link-button-android"
            rel="noreferrer"
          >
            <Button onClick={buttonClicked} className={classes.mobileButton}>
              <img src={androidImageSourceBtn} alt={buttonLabelMobile} />
            </Button>
          </a>
        )}
      </Col>
    );
  }

  return (
    <a
      href={successLink}
      rel="noreferrer"
      id="marketing-button-container"
      className="no-underline"
    >
      <RaisedButton
        onClick={buttonClicked}
        className={[classes.marketingSuccessButton, className]}
      >
        {children}
      </RaisedButton>
    </a>
  );
};

export default MarketingLoginButton;
